module.exports = __webpack_public_path__ + "img/photo-kk.0c0b7156.png";